// import "./App.scss";
// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
 //import { PublicClientApplication } from "@azure/msal-browser";
// import { config } from "../../../src/config";
// import { MsalProvider } from "@azure/msal-react";
// import AppLayout from "../AppLayout";
// import QuickSearch from "../Home/Home";
// import Login from "../../pages/Login";
// import Logout from "../../pages/Logout";
// import DRNUpload from "../DRNUpload/DRNUpload";
// import MainHeader from "../PublicComponents/MainHeader";
// import UnAuth from "../PublicComponents/UnAuth";
 //import { UserContextProvider } from "../../contexts/userContextApi";
// import AdvancedSearch from "../AdvancedSearch/AdvancedSearch";
// import useTelemetry from "../../opentelemetry-library/utils/useTelemetry";
// import  QNADisplay from "../Questionnaire/Questionnaire";
// import { useUser } from "../../contexts/userContextApi";
// function App() {
//   console.log("role in app.tsx", sessionStorage.getItem("role"));
//   const pca = new PublicClientApplication(config);
//   const { telemetryEnabled, handleTelemetryValue } = useTelemetry();
//   //const role = useUser()
//   /* 
//  -------------------------------------------------------------------------------------------------------------------
//  User have to create a function like we have created i.e. onButtonClick in their project that would be passed 
//  as prop to the component where button exists on click of which the tracing would start. In that component you just
//  need to pass this function as prop and use it onClick of the button.
//  ----------------------------------------------------------------------------------------------------------------------------
//  */
//   const startEventTrace = () => {
//     //initializeExporter();// don't need to pass anything in this function. Just call it.
//     handleTelemetryValue("Accept");// you have to pass the string "Accept" as an argument to this function.
//     return telemetryEnabled;//this will return the value of telemetryEnabled.
//     /*
//    ---------------------------------------------------------------------------------------------------------------------------------------- 
//     We need to pass value of telemetryEnabled to be passed as prop to all screens/ components where we want to use tracing.
//    --------------------------------------------------------------------------------------------------------------------------------------------
//     */
//   }
//   //console.log("role in app.tsx after console log",useUser()?.role);
//   return (
//     <MsalProvider instance={pca}>
//       <UserContextProvider>
//         <BrowserRouter>
//           <MainHeader />
//           <Routes>
//             <Route path="/" element={<Login startEventTrace={startEventTrace} />} />
//             {/*nav routes*/}
//             <Route path="/drn" element={<AppLayout />}>
//               <Route index element={<Navigate to="quickSearch" replace />} />
//               <Route path="quickSearch" element={<QuickSearch/>} />
//               <Route path="uploadDrn" element={<DRNUpload />} />
//               <Route path="advancedSearch" element={<AdvancedSearch />} />
//               <Route path="questionnaire" element={<QNADisplay/>} />
//               <Route path="logout" element={<Logout />} />
//             </Route>
//             <Route path="/UnAuthorize" element={<UnAuth />} />
//             <Route path="*" element={<Navigate to="/" />} />
//           </Routes>
//         </BrowserRouter>
//       </UserContextProvider>
//     </MsalProvider>
//   );
// }
// export default App;

import "./App.scss";
import { PublicClientApplication } from "@azure/msal-browser";
import { config } from "../../../src/config";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom"; // ✅ ADD THIS
import AppContent from "./AppContent";
import { UserContextProvider } from "../../contexts/userContextApi";
function App() {
  const pca = new PublicClientApplication(config);

  return (
    <MsalProvider instance={pca}>
      <UserContextProvider>
        <BrowserRouter> {/* ✅ MUST be here */}
          <AppContent />
        </BrowserRouter>
      </UserContextProvider>
    </MsalProvider>
  );
}

export default App;